import styled, { css } from 'styled-components';
import { MAP_CELL_MODES } from './BaseTable.constants';
// styled-components.
// -----------------------------------------------------------------------------
export const BaseTableRoot = styled.table `
  ${({ borderType, fullWidth, mode, zebra }) => {
    const { actionsColor, bgColor, bgColorHover, borderColor, textColor } = MAP_CELL_MODES[mode];
    return css `
      // Box model.
      border-collapse: collapse;
      width: ${fullWidth ? '100%' : 'auto'};

      // Colors.
      border: 1px solid ${borderColor};

      // Headers.
      thead > tr {
        border-bottom: 1px solid ${borderColor};
      }

      th,
      td {
        background-color: ${bgColor};
        color: ${textColor};
      }

      td.actions-ctas .actions-ctas-menu {
        color: ${actionsColor};
      }

      // Elements.
      ${borderType === 'column' &&
        `
        th, td {
          border-left: 1px solid ${borderColor};
          border-right: 1px solid ${borderColor};
        }
      `}

      ${borderType === 'full' &&
        `
        th, td {
          border: 1px solid ${borderColor};
        }
      `}

      ${borderType === 'none' && ``}

      ${borderType === 'row' &&
        `
        tr {
          border: 1px solid ${borderColor};
        }
      `}

      ${zebra &&
        `
        tbody tr:nth-child(odd) td {
          background-color: ${bgColorHover};
        }
      `}
    `;
}}
`;
//# sourceMappingURL=BaseTable.styled.js.map